import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var CheckSolidIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.211 5.404a1.507 1.507 0 012.055 0l.268.251a1.462 1.462 0 010 2.14l-11.539 10.8c-.576.54-1.478.54-2.054 0l-5.475-5.124a1.462 1.462 0 010-2.14l.268-.25a1.507 1.507 0 012.055 0l4.179 3.911L19.21 5.404z", fill: "currentColor" })] })));
};

export { CheckSolidIcon };
//# sourceMappingURL=CheckSolidIcon.js.map
